import { defineRecipe } from '@chakra-ui/react';
import { fieldFill } from '../themeColor';

/**
 * md text is 16px so iOS Safari does not zoom on focus.
 * Outline's default fill is transparent, which makes a field disappear into
 * the sidebar. The wash stays a step off both the page and the panel.
 */
export const inputRecipe = defineRecipe({
  base: {
    bg: fieldFill,
    borderWidth: 'hairline',
  },
  variants: {
    variant: {
      outline: {
        bg: fieldFill,
      },
    },
    size: {
      md: {
        textStyle: 'md',
      },
    },
  },
});

export const textareaRecipe = defineRecipe({
  base: {
    bg: fieldFill,
    borderWidth: 'hairline',
  },
  variants: {
    variant: {
      outline: {
        bg: fieldFill,
      },
    },
    size: {
      md: {
        textStyle: 'md',
      },
    },
  },
});
